module.exports = __webpack_public_path__ + "media/images/qr_code_icon-610a3a4ac47adb6f6f13e8361e2aefdb.svg";